export const translations = {
  'English (U.S.)': {
    translation: {
      // Default, no need to translate.
    },
  },
};
